// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__10CxL","form":"styles_form__Ho_lT"};